export const PAYCOM_APPLICATION_URL =
  "https://www.paycomonline.net/v4/ats/web.php/Session/index/login?clientkey=5366DC618FC4CB8BE878F1AD7A436F31";
